/**
 * The viewport widths the public pages are prerendered at, one HTML file each (utilities/pageMetaPrerenderPlugin.ts).
 * The CMS serves the mobile file to phones (packages/cms/src/middlewares/website.ts). The public pages only tell
 * desktop (992 px and up) from phone layouts, so 1440 stands for every desktop and 390 for every phone.
 */
export const PRERENDER_WIDTHS = { desktop: 1440, mobile: 390 } as const

export type PrerenderVariant = keyof typeof PRERENDER_WIDTHS

let serverWidth: number = PRERENDER_WIDTHS.desktop

/** Build time: the width the page about to be rendered is laid out for. */
export const setPrerenderWidth = (width: number): void => {
  serverWidth = width
}

/**
 * The width the page's HTML was rendered at: on the server, the one being rendered; in the browser, the one the
 * prerender stamped on #root (`data-prerender-width`).
 */
export const getPrerenderWidth = (): number => {
  if (typeof document === "undefined") return serverWidth
  return Number(document.getElementById("root")?.dataset.prerenderWidth) || PRERENDER_WIDTHS.desktop
}
